import * as React from "react";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import "./Progress.css";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Skeleton } from "@mui/material";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
// import { actionid } from "../../../../redux/features/pageSlices";
import { actionid } from "../../../redux/features/pageSlices";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { common_axios } from "../../../App";
import CancelImg from "../../../assets/images/cancel.png";
import { setTimeSeries1 } from "../../../redux/features/dashboardSlice";
import moment from "moment";
function LinearProgressWithLabel(props) {
  // console.log({ props });

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress
          //   color="green"className="mt-1"
          className="mt-1"
          sx={{
            "& .MuiLinearProgress-bar1Determinate": {
              backgroundColor: props.colorr,
            },
          }}
          variant="determinate"
          {...props}
        />
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
  color: PropTypes.number.isRequired,
};

export default function ProgressBar({ value, firstDay, lastDay }) {
  const resd = useSelector((data) => data?.dashboardReducer);
  const [progress, setProgress] = React.useState(10);
  const [data, setData] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  //   const CampaignApi = async (e) => {
  //     try {
  //       setOpen(true);
  //       setData(null);
  //       const res = await axios.post(
  //         `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/campaigns/data`,
  //         {
  //             campaignRequest: {
  //               startDateTime: `${lastDay}`,
  //               endDateTime: `${firstDay}`,
  //             },
  //           }
  //       );

  //       if (res.data.status.statusCode == 200) {
  //         setOpen(false);

  //         setData({
  //           total: res.data?.total,
  //           processed: res.data?.processed,
  //           inProcess: res.data?.inProcess,
  //           onHold: res.data?.onHold,
  //           l1Pending: res.data?.l1Pending,
  //           pendingInward: res.data?.pendingInward,
  //           cancellation: res.data?.cancellation,
  //         });
  //         // console.log("dataaaa", res.data.walletBalance);
  //       } else {
  //         setData([]);
  //         setOpen(false);

  //         Swal.fire({
  //           icon: "error",
  //           //  title: "Oops...",
  //           text: res.data.status.message,
  //           // footer: '<a href="">Why do I have this issue?</a>'
  //         });
  //       }
  //     } catch (error) {
  //       setData([]);
  //       setOpen(false);
  //       // console.log(error);
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: "Something went wrong",
  //         // footer: '<a href="">Why do I have this issue?</a>'
  //       });
  //     }
  //   };

  async function CampaignApi() {
    // setTableLoader(true);
    //
    try {
      setOpen(true);
      // setScheduleSkelton(true);
      // sethideSkeleton(true)
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/dashboard/v1/get/campaigns/data`,
        {
          campaignRequest: {
            startDateTime: resd?.timeSeries?.end,
            endDateTime: resd?.timeSeries?.start,
          },
        }
      );
      // console.log("------resultssss", result);
      if (result.data.statusDescription.statusCode == 200) {
        if (result?.data?.campaignCount) setData(result?.data?.campaignCount);
      } else {
        // setScheduleSkelton(false);
        // sethideSkeleton(false)
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      //   console.log(error);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    } finally {
      setOpen(false);
    }
    // console.log("response..", res);
  }

  useEffect(() => {
    CampaignApi();
  }, [
    resd?.timeSeries?.start,
    resd?.timeSeries?.end,
    resd?.product,
    resd?.productType,
    // resd?.showBy,
    value,
  ]);

  return (
    <>
      {/* <Box sx={{ width: "100%" }}>
        <LinearProgressWithLabel value={progress} />
      </Box> */}
      {/* <div class="container-fluid"> */}

      {open ? (
        <>
          <Skeleton animation="wave" className="mt-3" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
        </>
      ) : (
        <>
          {!data ||
          (data?.totalCampaignCount !== null &&
            data?.totalCampaignCount === 0) ? (
            <div className="d-flex h-100 p-3">
              <div className="m-auto text-center">
                <h1>No Data</h1>
                <img
                  style={{ width: "100px", maxWidth: "100%" }}
                  src={CancelImg}
                  alt=""
                  srcset=""
                />
              </div>
            </div>
          ) : (
            <div class="row mt-2" id="statistics">
              <div class="col-12 mt-2">
                <Link
                  onClick={() => {
                    if (
                      JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
                      "ROLE_SUPER_ADMIN"
                    ) {
                      dispatch(actionid("1"));
                      document
                        .getElementsByName("sidebarLiCampaign Manager")?.[0]
                        ?.click();
                      history.replace("/dashboard/CampaignsControl");
                    } else {
                      dispatch(actionid("1"));
                      document
                        .getElementsByName("sidebarLiCampaign Manager")?.[0]
                        ?.click();
                      history.replace("/dashboard/CampaignControl");
                    }
                  }}
                >
                  <div class="card subCard">
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="d-block text-capitalize spn">Scheduled</span>

                      <span class="d-block text-capitalize fw-bold">
                        {data?.scheduled} / {data?.totalCampaignCount}
                        {/* {0} / {0} */}
                      </span>
                    </div>
                    {/* <hr class="d-block hr_bg_orange m-0 mt-3" /> */}
                    <LinearProgressWithLabel
                      // colorr={"blue"}
                      colorr={data?.scheduled == 0 ? "#A7CAED" : "#7b5ee4"}
                      // value={Math.round((0/ 0) * 100)}
                      value={Math.round(
                        (data?.scheduled / data?.totalCampaignCount) * 100
                      )}
                    />
                  </div>
                </Link>

                <div
                  class="card my-2 subCard"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    dispatch(
                      setTimeSeries1({
                        end: `${resd?.timeSeries?.end}`,
                        start: `${resd?.timeSeries?.start}`,
                        dateType: "Daily",
                        approveType: "Completed",
                      })
                    );
                    document
                      .getElementsByName("sidebarLiReports")?.[0]
                      ?.click();
                    history?.push("/dashboard/TransactionalReport");
                  }}
                >
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="d-block text-capitalize spn">Completed</span>
                    <span class="d-block text-capitalize fw-bold">
                      {data?.completed} / {data?.totalCampaignCount}
                    </span>
                  </div>
                  <LinearProgressWithLabel
                    // colorr={"red"}
                    colorr={data?.completed == 0 ? "#A7CAED" : "#3f9143"}
                    value={Math.round(
                      (data?.completed / data?.totalCampaignCount) * 100
                    )}
                  />
                </div>

                <Link
                  onClick={() => {
                    if (
                      JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
                      "ROLE_SUPER_ADMIN"
                    ) {
                      dispatch(actionid("-1"));
                      document
                        .getElementsByName("sidebarLiCampaign Manager")?.[0]
                        ?.click();
                      history.replace("/dashboard/CampaignsControl");
                    } else {
                      dispatch(actionid("-1"));
                      document
                        .getElementsByName("sidebarLiCampaign Manager")?.[0]
                        ?.click();
                      history.replace("/dashboard/CampaignControl");
                    }
                  }}
                >
                  <div class="card subCard">
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="d-block text-capitalize spn">Pause</span>
                      <span class="d-block text-capitalize fw-bold">
                        {data?.pause} / {data?.totalCampaignCount}
                      </span>
                    </div>
                    <LinearProgressWithLabel
                      // colorr={"#fb8c00"}
                      colorr={data?.pause == 0 ? "#A7CAED" : "#f5ab2e"}
                      value={Math.round(
                        (data?.pause / data?.totalCampaignCount) * 100
                      )}
                    />
                    {/* <hr class="d-block hr_bg_green m-0 mt-3" /> */}
                  </div>
                </Link>
                <Link
                  onClick={() => {
                    if (
                      JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
                      "ROLE_SUPER_ADMIN"
                    ) {
                      dispatch(actionid("-1"));
                      document
                        .getElementsByName("sidebarLiCampaign Manager")?.[0]
                        ?.click();
                      history.replace("/dashboard/CampaignsControl");
                    } else {
                      dispatch(actionid("-1"));
                      document
                        .getElementsByName("sidebarLiCampaign Manager")?.[0]
                        ?.click();
                      history.replace("/dashboard/CampaignControl");
                    }
                  }}
                >
                  <div class="card mt-2 subCard">
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="d-block text-capitalize spn">Running</span>
                      <span class="d-block text-capitalize fw-bold">
                        {data?.inProcess} / {data?.totalCampaignCount}
                      </span>
                    </div>
                    <LinearProgressWithLabel
                      // colorr={"#7b809a"}
                      colorr={data?.inProcess == 0 ? "#A7CAED" : "#ce5c67"}
                      value={Math.round(
                        (data?.inProcess / data?.totalCampaignCount) * 100
                      )}
                    />
                  </div>
                </Link>

                <div
                  class="card mt-2 subCard"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    dispatch(
                      setTimeSeries1({
                        end: `${resd?.timeSeries?.end}`,
                        start: `${resd?.timeSeries?.start}`,
                        dateType: "Daily",
                        approveType: "Stopped",
                      })
                    );
                    document
                      .getElementsByName("sidebarLiReports")?.[0]
                      ?.click();
                    history?.push("/dashboard/TransactionalReport");
                  }}
                >
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="d-block text-capitalize spn">Stopped</span>
                    <span class="d-block text-capitalize fw-bold">
                      {data?.stopped} / {data?.totalCampaignCount}
                    </span>
                  </div>
                  <LinearProgressWithLabel
                    // colorr={"red"}
                    colorr={data?.stopped == 0 ? "#A7CAED" : "#f9442f"}
                    value={Math.round(
                      (data?.stopped / data?.totalCampaignCount) * 100
                    )}
                  />
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {/* </div> */}
    </>
  );
}
